import React from 'react';
import Navbar from './global-components/navbar-v2';
import PageHeader from './global-components/page-header';
import Contact from './section-components/contact-page';
import Footer from './global-components/footer-v2';
import DemoDetail from "./section-components/demo-detail";

const ContactPage = () => {
    return <div>
        <PageHeader headertitle="Demo Links" />
        <DemoDetail />
    </div>
}

export default ContactPage

